import { CommandBar, ICommandBarStyles } from "@fluentui/react";
import React from "react";
import { ICommandBarMenuProps } from "./MenuItems/buildMenuItems";

const commandBarStyle: Partial<ICommandBarStyles> = {
  root: {
    borderTop: '1px solid rgb(237, 235, 233);',
    borderBottom: '1px solid rgb(237, 235, 233);',
    paddingLeft: 0,
    paddingRight: 10,
    paddingBottom: 3,
    paddingTop: 3
  }
};

export interface IContentBodyCommandBarProps {
  commandBarMenu: ICommandBarMenuProps;
}

export const ContentBodyCommandBar = ({ commandBarMenu }: IContentBodyCommandBarProps) => {
  return (
    <CommandBar
        styles={commandBarStyle}
        items={commandBarMenu ? commandBarMenu?.items : []}
        ariaLabel="Use left and right arrow keys to navigate between commands"
        farItems={commandBarMenu ? commandBarMenu?.farItems : []}
      />
  )
};
